import HttpService from "./htttp.service";

class TasksService {
  getTasks = async (query, cancelToken) => {
    const endpoint = "tasks";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  getTaskStatuses = async (query, cancelToken) => {
    const endpoint = "tasks/statuses";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  getTaskPriorities = async (query, cancelToken) => {
    const endpoint = "tasks/priorities";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  createTask = async (query, payload) => {
    const data = { ...payload };
    const endpoint = "tasks";
    const fileAttachments = [],
      urlAttachments = [];
    data.attachments?.forEach((attachment) => {
      if (attachment.url && typeof attachment.url != "string") {
        fileAttachments.push(attachment.url);
      } else {
        urlAttachments.push(attachment);
      }
    });

    if (data.attachments) data.attachments = urlAttachments;

    return await HttpService.uploadFilesWithData(
      endpoint,
      fileAttachments,
      data,
      "post",
    );
  };

  createTasks = async (query, payload) => {
    const endpoint = "tasks/bulk";
    return await HttpService.post(endpoint, payload, query);
  };

  removeTask = async (id) => {
    const endpoint = "tasks/" + id;
    return await HttpService.delete(endpoint, id);
  };

  /*updateTask = async (id, payload) => {
    const endpoint = "tasks/" + id;
    return await HttpService.put(endpoint, payload);
  };*/

  updateTask = async (id, payload) => {
    const data = { ...payload };
    const endpoint = "tasks/" + id;
    const fileAttachments = [],
      urlAttachments = [];
    data.attachments?.forEach((attachment) => {
      if (attachment.url && typeof attachment.url != "string") {
        fileAttachments.push(attachment.url);
      } else {
        urlAttachments.push(attachment);
      }
    });

    if (data.attachments) data.attachments = urlAttachments;

    return await HttpService.uploadFilesWithData(
      endpoint,
      fileAttachments,
      data,
      "put",
    );
  };

  answerTask = async (id, payload) => {
    const data = { ...payload };
    const endpoint = "tasks/" + id + "/answer";
    const fileAttachments = [],
      urlAttachments = [];
    data.attachments?.forEach((attachment) => {
      if (attachment.url && typeof attachment.url != "string") {
        fileAttachments.push(attachment.url);
      } else {
        urlAttachments.push(attachment);
      }
    });

    if (data.attachments) data.attachments = urlAttachments;

    return await HttpService.uploadFilesWithData(
      endpoint,
      fileAttachments,
      data,
      "put",
    );
  };

  approveSuggestedDueDate = async (id) => {
    const endpoint = "tasks/" + id + "/approve-due-date";
    return await HttpService.put(endpoint, id);
  };

  denySuggestedDueDate = async (id) => {
    const endpoint = "tasks/" + id + "/deny-due-date";
    return await HttpService.put(endpoint, id);
  };
}

export default new TasksService();
